var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VButtonIcon',{staticClass:"modal-close",attrs:{"color":"dark","icon-size":"small"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('CloseSVG')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }